import React, { createContext, useContext, useState, useCallback } from 'react';

interface RegisterAddedContextData {
  hasProductUpdated: boolean;
  hasGroupUpdated: boolean;
  hasComplementoUpdated: boolean;
  drawerWasClosed: boolean;
  complementoDrawerClosed: boolean;

  handleSetHasProductUpdated(value: boolean): void;
  handleSetHasGroupUpdated(value: boolean): void;
  handleSetComplementoUpdated(value: boolean): void;
  handleSetDrawerWasClosed(value: boolean): void;
  handleSetComplementoDrawerClosed(value: boolean): void;
}

const RegisterAddedContext = createContext<RegisterAddedContextData>(
  {} as RegisterAddedContextData,
);

const RegisterAddedProvider: React.FC = ({ children }) => {
  const [productUpdated, setProductUpdated] = useState(false);
  const [grupoUpdated, setGroupUpdated] = useState(false);
  const [hasComplementoUpdated, setHasComplementoUpdated] = useState(false);
  const [drawerWasClosed, setDrawerWasClosed] = useState(false);
  const [complementoDrawerClosed, setComplementoDrawerClosed] = useState(false);

  const handleSetHasProductUpdated = useCallback((value: boolean) => {
    setProductUpdated(value);
  }, []);

  const handleSetHasGroupUpdated = useCallback((value: boolean) => {
    setGroupUpdated(value);
  }, []);

  const handleSetComplementoUpdated = useCallback((value: boolean) => {
    setHasComplementoUpdated(value);
  }, []);

  const handleSetDrawerWasClosed = useCallback((value: boolean) => {
    setDrawerWasClosed(value);
  }, []);

  const handleSetComplementoDrawerClosed = useCallback((value: boolean) => {
    setComplementoDrawerClosed(value);
  }, []);

  return (
    <RegisterAddedContext.Provider
      value={{
        hasProductUpdated: productUpdated,
        hasGroupUpdated: grupoUpdated,
        hasComplementoUpdated,
        drawerWasClosed,
        complementoDrawerClosed,
        handleSetHasProductUpdated,
        handleSetHasGroupUpdated,
        handleSetComplementoUpdated,
        handleSetDrawerWasClosed,
        handleSetComplementoDrawerClosed,
      }}
    >
      {children}
    </RegisterAddedContext.Provider>
  );
};

function useRegisterAdded(): RegisterAddedContextData {
  const context = useContext(RegisterAddedContext);

  if (!context)
    throw new Error(
      'useRegisterAdded deve ser utilizado junto do RegisterAddedProvider',
    );

  return context;
}

export { RegisterAddedProvider, useRegisterAdded };
